import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { getSpacingClasses } from '../../utils/getSpacingClasses';

export default function save({ attributes }) {

  const blockProps = useBlockProps.save({
    className: `column ${getSpacingClasses(attributes)}`,
  });

  return (
    <div {...blockProps}>
      <InnerBlocks.Content />
    </div>
  );
}
